export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/RendererWorker.b817ef8e.worker.js");
}
